import type { RibbonMenuButtonState } from "./RibbonFlyoutAnchor.types";

// eslint-disable-next-line no-restricted-imports
import type { AppMenuButtonProps } from "@1js/acui-button/lib/Next";

import { useRibbonButtonVariant } from "../../RibbonButton/next/useRibbonButtonVariant";
import { getDownChevronIcon } from "@1js/acui-icons";

export const useRibbonMenuButtonState = (
  props: AppMenuButtonProps,
  state: RibbonMenuButtonState
) => {
  const { variant, variantId } = props;
  const { size } = state;
  useRibbonButtonVariant(
    state,
    variant as RibbonMenuButtonState["variant"],
    variantId as RibbonMenuButtonState["variantId"]
  );

  if (
    state.variant === "ribbonModeButton" ||
    state.variant === "overflowButton"
  ) {
    // For ribbon mode flyout anchor & overflow buttons, we actually want it to be "icon only" and hide the menu icon
    state.iconOnly = true;
    state.root.children = undefined;
  }

  if (size === "large" && getDownChevronIcon(props) && state.menuIcon) {
    // Only remove the menuIcon if the label (root.children) exists
    if (state.root.children) {
      // Remove the menuIcon for large menu buttons
      // It gets rendered within the label itself (root.children) if the label (root.children) exists
      state.menuIcon.children = undefined;
    }
  }

  return state;
};
